import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from '../../../models/allpayments'; // Importing allpayments model
import { devConfig, countries, gamesCasino } from '../../../config/config'; // Importing configuration settings

/**
 * Class representing a table view.
 * @extends JetView
 */
export default class tableView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable', // DataTable view
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        // Template function for rendering cell content
                                        if (devConfig.getPermAction('fringeEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon if permission granted
                                        } else {
                                            return ''; // No icon if permission denied
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'Id', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'GlobalId', // Column ID
                                    header: 'Global Id', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Content', // Column ID
                                    header: _('Contenido'), // Localized column header
                                    width: 500, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientId', // Column ID
                                    header: _('Usuarios Id'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Redirection', // Column ID
                                    header: _('URL Redirección'), // Localized column header
                                    width: 350, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CountrySelect', // Column ID
                                    header: _('País'), // Localized column header
                                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Hide column based on permission
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DateSend', // Column ID
                                    header: _('Fecha envío'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DateExpiration', // Column ID
                                    header: _('Fecha expiración'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activo') }, // Active state
                                        { id: 'I', value: _('Inactivo') }, // Inactive state
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Leido'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: '1', value: _('Si') }, // Yes option
                                        { id: '0', value: _('No') }, // No option
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    // Click event for edit action
                                    $$('EditFringe').show(); // Show edit popup
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Get the datatable instance
        var url = devConfig.geturlApi() + 'Client/GetClientSendFringe'; // API URL for fetching data
        var filter = ''; // Filter string for API requests
        var createdLocalDate = // Local date string for default date fields
            webix.Date.add(new Date(), -0, 'day').getFullYear() +
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2) +
            ' ' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getHours()).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getMinutes()).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getSeconds()).slice(-2);
        var popupSendFringe = webix.ui({
            // Popup for sending fringe
            view: 'window',
            id: 'SendFringe', // ID for the popup
            width: screen.width < 500 ? 350 : 650, // Width based on screen size
            height: screen.width < 500 ? 850 : 650, // Height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                view: 'toolbar', // Toolbar for the popup header
                cols: [
                    {
                        view: 'label',
                        label: _('Enviar franja'), // Localized label
                        align: 'center', // Center alignment
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            // Click event to close the popup
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center position for the popup
            modal: true, // Modal popup
            body: {
                view: 'scrollview', // Scrollable view
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form for input fields
                    id: 'formSendFringe', // ID for the form
                    width: screen.width < 500 ? 350 : 650, // Width based on screen size
                    height: screen.width < 500 ? 850 : 600, // Height based on screen size
                    elements: [
                        {
                            view: 'textarea', // Textarea for content input
                            label: _('Contenido'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Content', // Name for the input
                            labelWidth: 150, // Label width
                            required: true, // Required field
                        },
                        {
                            view: 'textarea', // Textarea for user IDs input
                            label: _('Usuarios Id'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'ClientId', // Name for the input
                            labelWidth: 150, // Label width
                            required: true, // Required field
                        },
                        {
                            view: 'text', // Text input for redirection URL
                            label: _('URL Redirección'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Redirection', // Name for the input
                            labelWidth: 150, // Label width
                            required: true, // Required field
                        },
                        {
                            view: 'richselect', // Rich select for country selection
                            name: 'CountrySelect', // Name for the input
                            label: "<span class='icon-language'></span>" + _('País'), // Localized label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            labelWidth: 150, // Label width
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for rendering options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data for the options
                                },
                            },
                            required: true, // Required field
                        },
                        {
                            view: 'datepicker', // Datepicker for sending date
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha envío'), // Localized label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'DateSend', // Name for the input
                            stringResult: true, // Return string result
                            labelWidth: 150, // Label width
                            format: '%d %M %Y %H:%i:%s', // Date format
                            required: true, // Required field
                            timepicker: true, // Enable timepicker
                            value: createdLocalDate, // Default value
                        },
                        {
                            view: 'datepicker', // Datepicker for expiration date
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha expiración'), // Localized label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'DateExpiration', // Name for the input
                            stringResult: true, // Return string result
                            labelWidth: 150, // Label width
                            format: '%d %M %Y %H:%i:%s', // Date format
                            required: true, // Required field
                            timepicker: true, // Enable timepicker
                            value: createdLocalDate, // Default value
                        },
                        {
                            cols: [
                                // Button layout
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'), // Localized label
                                    click: function () {
                                        // Click event to cancel
                                        this.getTopParentView().hide(); // Hide the popup
                                        $$('formSendFringe').setValues(
                                            // Reset form values
                                            $$('formSendFringe').getCleanValues(),
                                        );
                                    },
                                },
                                {
                                    view: 'button', // Send button
                                    type: 'form', // Button type
                                    value: _('Enviar'), // Localized label
                                    click: function ($e) {
                                        // Click event to send data
                                        var values = $$('formSendFringe').getValues(); // Get form values
                                        if ($$('formSendFringe').validate()) {
                                            // Validate form
                                            webix
                                                .ajax() // AJAX request to send data
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/SendFringe', // API URL
                                                    '{"Content":"' +
                                                        values.Content +
                                                        '", "ClientId":"' +
                                                        values.ClientId +
                                                        '" , "Redirection":"' +
                                                        values.Redirection +
                                                        '", "CountrySelect":"' +
                                                        values.CountrySelect +
                                                        '", "DateSend":"' +
                                                        values.DateSend +
                                                        '", "DateExpiration":"' +
                                                        values.DateExpiration +
                                                        '"}', // JSON payload
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            data = JSON.parse(
                                                                text, // Parse response
                                                            );
                                                            if (data.HasError) {
                                                                // Check for errors
                                                                webix.message({
                                                                    text: _(
                                                                        'Error, comuniquese con soporte. ', // Error message
                                                                    ),
                                                                    type: 'error',
                                                                });
                                                            } else {
                                                                webix.message(
                                                                    _(
                                                                        'Franja enviada satisfactoriamente', // Success message
                                                                    ),
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                            $$('formSendFringe').setValues(
                                                // Reset form values
                                                $$('formSendFringe').getCleanValues(),
                                            );
                                            this.getTopParentView().hide(); // Hide the popup
                                        } else {
                                            webix.message({
                                                title: '¡Error!', // Error title
                                                type: 'alert-error', // Error type
                                                text: _(
                                                    'Completa los campos...', // Error message
                                                ),
                                            });
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                    elementsConfig: {
                        on: {
                            onChange: function () {
                                // Change event for validation
                                this.validate(); // Validate the form
                            },
                        },
                    },
                },
            },
        });
        var popupEditFringe = webix.ui({
            // Popup for editing fringe
            view: 'window',
            id: 'EditFringe', // ID for the popup
            width: screen.width < 500 ? 350 : 650, // Width based on screen size
            height: screen.width < 500 ? 850 : 650, // Height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                view: 'toolbar', // Toolbar for the popup header
                cols: [
                    {
                        view: 'label',
                        label: _('Editar franja'), // Localized label
                        align: 'center', // Center alignment
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            // Click event to close the popup
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center position for the popup
            modal: true, // Modal popup
            body: {
                view: 'scrollview', // Scrollable view
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form for input fields
                    id: 'formEditFringe', // ID for the form
                    width: screen.width < 500 ? 350 : 650, // Width based on screen size
                    height: screen.width < 500 ? 850 : 600, // Height based on screen size
                    elements: [
                        {
                            view: 'text', // Text input for ID
                            label: _('Id'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Id', // Name for the input
                            labelWidth: 150, // Label width
                            readonly: true, // Read-only field
                        },
                        {
                            view: 'textarea', // Textarea for content input
                            label: _('Contenido'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Content', // Name for the input
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'textarea', // Textarea for user IDs input
                            label: _('Usuarios Id'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'ClientId', // Name for the input
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'text', // Text input for redirection URL
                            label: _('URL Redirección'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'Redirection', // Name for the input
                            labelWidth: 150, // Label width
                            id: 'Redirection', // ID for the input
                        },
                        {
                            view: 'richselect', // Rich select for country selection
                            name: 'CountrySelect', // Name for the input
                            label: "<span class='icon-language'></span>" + _('País'), // Localized label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            labelWidth: 150, // Label width
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for rendering options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data for the options
                                },
                            },
                        },
                        {
                            view: 'datepicker', // Datepicker for sending date
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha envío'), // Localized label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'DateSend', // Name for the input
                            stringResult: true, // Return string result
                            labelWidth: 150, // Label width
                            format: '%d %M %Y %H:%i:%s', // Date format
                            timepicker: true, // Enable timepicker
                            value: createdLocalDate, // Default value
                        },
                        {
                            view: 'datepicker', // Datepicker for expiration date
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha expiración'), // Localized label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'DateExpiration', // Name for the input
                            stringResult: true, // Return string result
                            labelWidth: 150, // Label width
                            format: '%d %M %Y %H:%i:%s', // Date format
                            timepicker: true, // Enable timepicker
                            value: createdLocalDate, // Default value
                        },
                        {
                            view: 'combo', // Combo for state selection
                            label: _('Estado'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            name: 'State', // Name for the input
                            options: [
                                // Options for the combo
                                { id: 'A', value: _('Activado') }, // Activated state
                                { id: 'I', value: _('Inactivado') }, // Deactivated state
                            ],
                            labelWidth: 150, // Label width
                        },
                        {
                            cols: [
                                // Button layout
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'), // Localized label
                                    click: function () {
                                        // Click event to cancel
                                        this.getTopParentView().hide(); // Hide the popup
                                        $$('formEditFringe').setValues(
                                            // Reset form values
                                            $$('formEditFringe').getCleanValues(),
                                        );
                                    },
                                },
                                {
                                    view: 'button', // Send button
                                    type: 'form', // Button type
                                    value: _('Enviar'), // Localized label
                                    click: function ($e) {
                                        // Click event to send data
                                        var values = $$('formEditFringe').getValues(); // Get form values
                                        webix
                                            .ajax() // AJAX request to send data
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Client/SendFringe', // API URL
                                                '{"Id":"' +
                                                    values.Id +
                                                    '", "Content":"' +
                                                    values.Content +
                                                    '", "ClientId":"' +
                                                    values.ClientId +
                                                    '" , "Redirection":"' +
                                                    values.Redirection +
                                                    '", "CountrySelect":"' +
                                                    values.CountrySelect +
                                                    '", "DateSend":"' +
                                                    values.DateSend +
                                                    '", "DateExpiration":"' +
                                                    values.DateExpiration +
                                                    '", "State":"' +
                                                    values.State +
                                                    '"}', // JSON payload
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        data = JSON.parse(text); // Parse response
                                                        if (data.HasError) {
                                                            // Check for errors
                                                            webix.message({
                                                                text: _(
                                                                    'Error, comuniquese con soporte. ', // Error message
                                                                ),
                                                                type: 'error',
                                                            });
                                                        } else {
                                                            webix.message(
                                                                _(
                                                                    'Franja editada satisfactoriamente', // Success message
                                                                ),
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                        $$('formEditFringe').setValues(
                                            // Reset form values
                                            $$('formEditFringe').getCleanValues(),
                                        );
                                        this.getTopParentView().hide(); // Hide the popup
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        $$('formEditFringe').bind($$('datatable')); // Bind the edit form to the datatable
        this.on(this.app, 'messages:filter', (filterData) => {
            // Event handler for filtering messages
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the datatable
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        this.on(this.app, 'sendfringe:button', (filterData) => {
            // Event handler for sending fringe
            popupSendFringe.show(); // Show send popup
            $$('formSendFringe').clearValidation(); // Clear validation errors
        });
    }
}

// FILE DOCUMENTED
